import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Facet } from '../../../../core/model';

@Component({
  selector: 'py-catalog-filter-facet',
  templateUrl: './catalog-filter-facet.component.html',
  styleUrls: ['./catalog-filter-facet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogFilterFacetComponent implements OnInit {
  @Input() facet: Facet;
  @Output() handleFilter = new EventEmitter<string>();
  @Input() set initialCollapsed(initialCollapsed: boolean) {
    this.isCollapsed = initialCollapsed;
  }
  @Input() set initialShowAll(initialShowAll: boolean) {
    this.showAll = initialShowAll;
  }

  @Input() displayedInDrawer: boolean = false;
  @Output() handleShowAll = new EventEmitter<boolean>();

  isCollapsed = true;
  searchValue = '';
  showAll = false;

  constructor() {}

  ngOnInit(): void {}

  handleChange($event) {
    this.handleFilter.emit($event);
  }

  handleSearch($event: any) {
    this.searchValue = $event.target.value;
  }

  setShowAll(showAll: boolean) {
    this.showAll = showAll;
    this.handleShowAll.emit(showAll);
  }

  onResetSearchInput(): void {
    this.searchValue = '';
  }

  get displayedValues() {
    let values = this.facet.values;
    if (this.searchValue && this.searchValue !== '') {
      values = this.facet.values.filter(
        (value) => value.name && value.name.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }

    if (!this.showAll) {
      return values.slice(0, 5);
    }

    return values;
  }

  get type(): string {
    return this.facet?.values?.length === 1 && this.facet?.values[0].name.toLowerCase() === 'true' ? 'Boolean' : '';
  }
}
